import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PaymentFailure from '../PaymentFailure';
import InvoiceSuccess from '../InvoiceSuccess';
import { useAppDispatch, useAppSelector } from '@store/store';
import { fetchTransactionInfoStart } from '@store/features/transaction/transactionSlice';

const PaymentStatus: React.FC = ({}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const { transactionDetails, success } = useAppSelector((state) => state.transaction);

  const transactionId = searchParams.get('transactionId');
  const state = searchParams.get('status');
  const isValidStatus = state === 'success' || state === 'failed' || state === 'pending';

  useEffect(() => {
    const hasSession = !!localStorage.getItem('okta-token-storage');
    if (!hasSession) {
      void navigate('/login');
      return;
    }

    if (!transactionId || !isValidStatus) {
      void navigate('/invoices');
      return;
    }

    dispatch(fetchTransactionInfoStart({ transactionId }));
  }, [dispatch, isValidStatus, navigate, transactionId]);

  return (
    <>
      {success && transactionDetails && (
        <div>
          {state === 'success' || state === 'pending' ? (
            <InvoiceSuccess isPending={state === 'pending'} />
          ) : (
            <PaymentFailure />
          )}
        </div>
      )}
    </>
  );
};

export default PaymentStatus;
